import { Ng2StateDeclaration } from '@uirouter/angular';
import { Transition } from '@uirouter/core';

import { DocmanPanelComponent } from './docmanPanel/docman.panel.controller';
import { ProjectHeaderComponent } from '../../core/modules/project/projectHeader/project.header.component';

import { DocmanResolvesService } from './docman-resolves.service';
import { TourService } from '../../core/modules/tour/tour.service';
import { ProjectModel } from '../../core/services/project.model.service';

export const DOCMAN_STATES: any[] = [
    {
        name: 'home.project.summary.docman',
        url: '/docs/*path?view&folder',
        params: {
            path: ''
        },
        data: {
            searchContext: ['docman']
        },
        resolve: [
            {
                token: 'security',
                deps: ['project', DocmanResolvesService, ProjectModel],
                resolveFn: async (project: any, docmanResolvesService: DocmanResolvesService, projectModel: ProjectModel) => {
                    return docmanResolvesService.security(project, projectModel);
                }
            },
            {
                token: 'tour',
                deps: [DocmanResolvesService, TourService],
                resolveFn: async (docmanResolvesService: DocmanResolvesService, tourService: TourService) => {
                    return docmanResolvesService.tour(tourService);
                }
            },
            {
                token: 'data',
                deps: ['$transition$', 'project', DocmanResolvesService],
                resolveFn: async (transition: any, project: any, docmanResolvesService: DocmanResolvesService) => {
                    const params = transition.params();
                    return docmanResolvesService.data(project, params.path, params.folder);
                }
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: DocmanPanelComponent
            }
        }
    }
];